import { ACM } from '../../../constants/UserRoles';

/**
 * Resolves the student ID for the current session from session state or fallback user data.
 */
export const getSessionStudentId = (sessionData = {}, user = {}) => {
  return sessionData?.studentId || user?.studentId || user?.id || null;
};

/**
 * Determines which top-level collection to use for a student's session notes.
 */
export const getSessionNotesCollectionName = (
  studentId,
  typeOfUser,
  preRegisteredUsers = []
) => {
  if (!studentId) {
    return null;
  }

  const isPreRegistered = preRegisteredUsers.some(
    (student) => student.id === studentId
  );

  if (isPreRegistered) {
    return 'preRegisteredUsers';
  }

  if (ACM[typeOfUser]?.isTeacher) {
    return 'studentsList';
  }

  return 'patientsList';
};

/**
 * Convenience helper that returns both the resolved student ID and collection name.
 */
export const getSessionNotesPathInfo = (
  sessionData,
  user,
  typeOfUser,
  preRegisteredUsers = []
) => {
  const studentId = getSessionStudentId(sessionData, user);
  if (!studentId) {
    throw new Error('Unable to determine student ID for this session.');
  }

  const collectionName = getSessionNotesCollectionName(
    studentId,
    typeOfUser,
    preRegisteredUsers
  );

  if (!collectionName) {
    throw new Error('Unable to determine collection for this session.');
  }

  return { studentId, collectionName };
};

